/**
 * Accident coverage skeleton
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getAccidentSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.ACCIDENT,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "accident-plan-1",
      name: "Accident Insurance Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      currentCarrierName: "",
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "accident",

        // Coverage Type
        coverageType: "onAndOffJob",

        // Hospital Admission
        hospitalAdmissionType: "notIncluded",
        hospitalAdmissionAmount: 1,

        // ICU Admission
        icuAdmissionType: "notIncluded",
        icuAdmissionAmount: 1,

        // Daily Hospital Confinement
        dailyHospitalConfinementType: "notIncluded",
        dailyHospitalConfinementAmount: 1,

        // Daily ICU Confinement
        dailyIcuConfinementType: "notIncluded",
        dailyIcuConfinementAmount: 1,

        // Ambulance - Air
        ambulanceAirType: "notIncluded",
        ambulanceAirAmount: 1,

        // Ambulance - Ground
        ambulanceGroundType: "notIncluded",
        ambulanceGroundAmount: 1,

        // Emergency Treatment
        emergencyTreatmentType: "notIncluded",
        emergencyTreatmentAmount: 1,

        // Urgent Care Visit
        urgentCareType: "notIncluded",
        urgentCareAmount: 1,

        // Initial Physician Office Visit
        initialPhysicianOfficeVisitType: "notIncluded",
        initialPhysicianOfficeVisitAmount: 1,

        // Dislocations Maximum
        dislocationsMaximumType: "notIncluded",
        dislocationsMaximumAmount: 1,

        // Fractures Maximum
        fracturesMaximumType: "notIncluded",
        fracturesMaximumAmount: 1,

        // Lacerations Maximum
        lacerationsMaximumType: "notIncluded",
        lacerationsMaximumAmount: 1,

        // Coma
        comaType: "notIncluded",
        comaAmount: 1,

        // Major Diagnostic Exam - X-Ray
        majorDiagnosticExamXrayType: "notIncluded",
        majorDiagnosticExamXrayAmount: 1,

        // Major Diagnostic Exam - MRI
        majorDiagnosticExamMriType: "notIncluded",
        majorDiagnosticExamMriAmount: 1,

        // Wellness Benefit
        wellnessBenefitType: "notIncluded",
        wellnessBenefitAmount: 1,

        // Child Organized Sports Enhancement
        childOrganizedSportsEnhancement: "notIncluded",

        // Portability
        portability: "notIncluded",

        // Age Reduction Schedule
        ageReductionScheduleType: "notIncluded",
        ageReductionScheduleSchedules: [],

        // Annual Open Enrollment
        annualOpenEnrollment: "notIncluded",

        // Extended (non-v5) fields — CD-390
        accidentalDeathDismemberment: undefined,
        eligibilityHours: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
